import { StyleSheet, View, ActivityIndicator } from 'react-native';
import React, { useEffect } from 'react';
import { useNavigation } from '@react-navigation/native';
import { navStack } from '../../Types/uitypes';
import { useFonts } from '@expo-google-fonts/poppins';
import { Poppins_700Bold } from '@expo-google-fonts/poppins';

export default function SplashScreen() {
    const navigation = useNavigation<navStack>();

    const [fontsLoaded] = useFonts({
        Poppins_700Bold,
    });

    useEffect(() => {
        if (!fontsLoaded) return; // ⛔ wait until font loads

        const init = async () => {
            try {
                navigation.navigate("OtpSignIn"); // better than navigate
            } catch (error) {
                console.error('Error checking user:', error);
                navigation.replace("OtpSignIn");
            }
        };

        init();
    }, [fontsLoaded]);

    return (
        <View style={styles.container}>
            <ActivityIndicator size="large" color="#007AFF" />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff',
    },
});